import { useEffect, useRef } from "react";
import { REVIEW_MODES } from "../lib/reviewWrite";
import { useReviewMode } from "../routes/useReviewMode";

/* HOW YOU SET NEXT WEEK — the coach's mode, on the Account (W82 §2, step 4): a row of three radios, one sentence each.
 * The review page reaches it through `How you set next week ›` (`#/page?show=review-mode`), which scrolls it into view
 * and moves focus to its legend. */
export function ReviewModeSetting({ coachId, focus }: { coachId: string; focus: boolean }) {
  const m = useReviewMode(coachId);
  const legend = useRef<HTMLLegendElement>(null);
  useEffect(() => {
    if (!focus || m.mode === null) return;
    legend.current?.scrollIntoView({ block: "center" });
    legend.current?.focus();
  }, [focus, m.mode]);
  return (
    <section id="review-mode" className="reviewmode" aria-label="How you set next week">
      <fieldset className="reviewmode-set" disabled={m.mode === null || m.saving}>
        <legend className="reviewmode-legend" tabIndex={-1} ref={legend}>How you set next week</legend>
        {REVIEW_MODES.map((c) => (
          <label key={c.value} className="reviewmode-choice">
            <input type="radio" name="review-mode" value={c.value} checked={m.mode === c.value} onChange={() => m.set(c.value)} />
            <span className="reviewmode-text">
              <span className="reviewmode-label">{c.label}</span>
              <span className="reviewmode-sentence">{c.sentence}</span>
            </span>
          </label>
        ))}
      </fieldset>
      {m.error !== null && <p className="ht-caption" role="alert">{m.error}</p>}
    </section>
  );
}
